import React, { useMemo } from 'react'
import { Tag, Typography } from 'antd'
import styled from 'styled-components'

import { EUserRole } from '../../constants/user'
import getRoleUser from '../../utils/getRoleUser'
import { Box } from '@mui/material'

const { Text } = Typography

interface IUsernameProps {
  username: string
  roles: string[]
}

const Username = (props: IUsernameProps) => {
  const roleProps: any = {
    [EUserRole.ADMIN]: {
      name: 'AD',
      color: '#52C41A',
    },
    [EUserRole.SUPER_ADMIN]: {
      name: 'SA',
      color: '#F5222D',
    },
    [EUserRole.MERCHANT]: {
      name: 'MC',
      color: '#f5ab22',
    },
    [EUserRole.USER]: {
      name: '',
      color: '#288EFF',
    },
    [EUserRole.HEAD]: {
      name: '',
      color: '#288EFF',
    },
    [EUserRole.ADVERTISER]: {
      name: '',
      color: '#288EFF',
    },
  }

  const roles = useMemo(() => {
    const { role } = getRoleUser(props?.roles ?? [])
    return role
  }, [props.roles])
  const roleProp = roleProps[roles]
  return (
    <Box sx={{ textAlign: 'left' }}>
      {roles !== EUserRole.USER && (
        <CustomTag color={roleProp.color}>{roleProps[roles].name}</CustomTag>
      )}
      <Text style={{ color: roleProp.color, fontWeight: 'bold' }}>
        {props.username}
      </Text>
    </Box>
  )
}

export default Username

const CustomTag = styled(Tag)<{ color: string }>`
  border-color: ${(c) => c.color};
  border-radius: 4px;
  font-weight: bold;
`
